import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_themeBase/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import moment from "moment";


const expiretionMinite = (typeof process !== "undefined" && process.env && process.env.ExpirationMinutes) ? process.env.ExpirationMinutes : 60;

const isLoginUser = (user) => {
    var now = moment.utc();
    let newValue = now.format("YYYY-MM-DDTHH:mm:ss");

    var expire = moment(user.lastLoginDate).add(expiretionMinite, 'minutes');
    let expireValue = expire.format("YYYY-MM-DDTHH:mm:ss");

    // now.setHours(d.getHours(), d.getMinutes() + expiretionMinite, 0, 0);
    if (user == null)
        return false
    if (expireValue <= newValue)
        return false
    else
        return true
}

export function Routes() {
    const { isAuthorized } = useSelector(
        ({ auth }) => ({
            isAuthorized: auth.user != null,
        }),
        shallowEqual
    );

    return (
        <>

            <Switch>

                {!isAuthorized ? (

                    /*Render auth page when user at `/auth` and not authorized.*/
                    <Route>

                        <AuthPage />
                    </Route>
                ) : (
                    /*Otherwise redirect to root page (`/`)*/
                    <Redirect from="/auth" to="/" />
                    // <Route>

                    //     <OPTPage />
                    // </Route>
                )}

                {/* <Route path="/auth/opt" component={OPTPage} /> */}
                <Route path="/error" component={ErrorsPage} />
                <Route path="/logout" component={Logout} />


                {!isAuthorized ? (
                    /*Redirect to `/auth` when user is not authorized*/
                    <Redirect to="/auth/login" />
                ) : (

                    <Layout>
                        <BasePage />
                    </Layout>

                )}
            </Switch>
        </>
    );
}
